import { TableStructure } from "../components/TableStructure";
import { SocialWelfareLeftMenuList } from "../utils/constants";

const GR_Recipients = () => (
  <TableStructure
    title="GR Recipients"
    heading={false}
    list={[
      {
        fileStoreId: "18023826-2a59-4f3c-8a94-891f18042026",
        label: "List of Recipients of GR 2009-2010",
      },
    ]}
    columnNo={1}
    leftMenuList={SocialWelfareLeftMenuList}
  />
);

export default GR_Recipients;
